import { render } from "./reset-master-pass.vue?vue&type=template&id=5b6e83e7"
import script from "./reset-master-pass.vue?vue&type=script&lang=js"
export * from "./reset-master-pass.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__